module.exports = __webpack_public_path__ + "img/peach-2.58242da.png";